require('./bootstrap');

import {createApp} from 'vue'
import { createI18n } from 'vue-i18n'
import Locales from './vue-i18n-locales.generated';
import axios from 'axios';
import accounting from '@/utils/accounting'
import VueMatomo from 'vue-matomo'

import moment from 'moment';
/*import 'litepicker-polyfills-ie11';*/
import Litepicker from 'litepicker';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'

const tooltipOptions = {
    name: 'VueCustomTooltip',
    color: '#fff',
    background: '#576874',
    borderRadius: 0,
    fontWeight: 300,
}

const i18n = createI18n({
    locale: 'de',
    fallbackLocale: 'en',
    messages: Locales
})

import App from '@/App.vue'
import store from './store'
import router from './router'
import mitt from 'mitt';
const emitter = mitt();

const appId = '#app'
const appEl = document.querySelector(appId);
const initialData = JSON.parse(appEl.dataset.init)

Object.keys(appEl.dataset).forEach(dataKey => {
    delete appEl.dataset[dataKey];
});

const app = createApp(App, {initialData: initialData});

//console.log('process',process)
app.config.globalProperties.$APP_URL = process.env.MIX_APP_URL;
app.config.globalProperties.$APP_VERSION = process.env.MIX_APP_VERSION;
//console.log('process.env.APP_VERSION',process.env.APP_VERSION)
const components = require.context('@/components/', true, /\.vue$/i);
components.keys().map(key => app.component(key.split('/').pop().split('.')[0], components(key).default));
app.use(router);
app.use(store);
app.use(VueCustomTooltip, tooltipOptions)
app.config.globalProperties.$http = axios;
app.config.globalProperties.$emitter = emitter;
app.config.globalProperties.$litepicker = Litepicker
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$accounting = accounting;


if(window.APP_ENV == 'production'){

    app.use(VueMatomo, {
        host: 'https://matomo.bdew-heizkostenvergleich.de/',
        siteId: 1,
        router: router
    });
}

const token = localStorage.getItem('token')
if (token) {
    app.config.globalProperties.$http.defaults.headers.common['Authorization'] = token
}

app.use(i18n);

app.mount(appId);
